import { RoleModuleConfig } from './types';
import { SponsorOverviewSlice } from '@restore/sponsorOverview/sponsorOverview.slice';
import { sponsorOverviewFiltersSlice } from '@restore/sponsorOverviewFilters/sponsorOverviewFilters.slice';
import {
  sponsorEligibilitySaga,
  SponsorEligibilitySlice,
} from '@restore/sponsorEligibility';
import {
  sponsorStatisticsSaga,
  SponsorStatisticsSlice,
} from '@restore/sponsorStatistics';
import { auditTrialsSlice } from '@restore/auditTrailsFilters/auditFilters.slice';
import { sponsorOverviewSaga } from '@restore/sponsorOverview/sponsorOverview.saga';
import { auditFiltersSaga } from '@restore/auditTrailsFilters/auditFilters.saga';
import { readerTaskSlice } from '../readerTask/readerTask.slice';
import { readerTaskSaga } from '../readerTask/readerTask.saga';
import { readerTaskOrchestrationSlice } from '../readerTaskOrchestration/readerTaskOrchestration.slice';
import { DICOMViewerSlice } from '../DICOMViewer/DICOMViewer.slice';
import { SimpleViewerSlice } from '../DICOMViewer/modes/SimpleViewer/SimpleViewer.slice';
import { clinicalTrialContextSlice } from '../clinicalTrialContext/clinicalTrialContext.slice';
import { ReaderTasksListSlice } from '../ReaderTasks/ReaderTasksList.slice';
import { DXAScoringFormSaga } from '../DXAScoringForm/DXAScoringForm.saga';
import { measurementsSaga } from '../measurements/measurements.saga';
import { DICOMViewerSaga } from '../DICOMViewer/DICOMViewer.saga';
import { SimpleViewerSaga } from '../DICOMViewer/modes/SimpleViewer/SimpleViewer.saga';
import { websocketsSaga } from '../WebSocket.saga';
import { readerSubTaskSaga } from '../readerSubTask/readerSubTask.saga';
import { readerTaskOrchestrationSaga } from '../readerTaskOrchestration/readerTaskOrchestration.saga';
import { ReaderTasksListSaga } from '@restore/ReaderTasks/ReaderTasks.saga';
import { DXAScoringFormSlice } from '../DXAScoringForm/DXAScoringForm.slice';
import { measurementsSlice } from '../measurements/measurements.slice';
import { readerSubTaskSlice } from '../readerSubTask/readerSubTask.slice';
import { formManagementSlice } from '../readerViewerSession/formManagement/formManagement.slice';
import { tabCoordinationSlice } from '../readerViewerSession/tabCoordination/tabCoordination.slice';
import { tabCoordinationSaga } from '../readerViewerSession/tabCoordination/tabCoordination.saga';
import { clinicalTrialInventorySlice } from '../clinicalTrialInventory/clinicalTrialInventory.slice';
import { clinicalTrialInventorySaga } from '../clinicalTrialInventory/clinicalTrialInventory.saga';
import { formManagementSaga } from '../readerViewerSession/formManagement/formManagement.saga';
import { segmentationSlice } from '../segmentation/segmentation.slice';
import { segmentationSaga } from '../segmentation/segmentation.saga';
import { queriesSlice } from '../queries/queries.slice';
import { queriesSaga } from '../queries/queries.saga';

export const sponsorModules: RoleModuleConfig = {
  slices: [
    SponsorOverviewSlice,
    sponsorOverviewFiltersSlice,
    SponsorEligibilitySlice,
    SponsorStatisticsSlice,
    auditTrialsSlice,
    clinicalTrialInventorySlice,
    DXAScoringFormSlice,
    measurementsSlice,
    DICOMViewerSlice,
    SimpleViewerSlice,
    readerTaskSlice,
    ReaderTasksListSlice,
    readerSubTaskSlice,
    readerTaskOrchestrationSlice,
    clinicalTrialContextSlice,
    tabCoordinationSlice,
    formManagementSlice,
    segmentationSlice,
    queriesSlice,
  ],
  sagas: {
    sponsorOverviewSaga,
    sponsorEligibilitySaga,
    sponsorStatisticsSaga,
    auditFiltersSaga,
    readerTaskSaga,
    DXAScoringFormSaga,
    measurementsSaga,
    DICOMViewerSaga,
    SimpleViewerSaga,
    websocketsSaga,
    ReaderTasksListSaga,
    readerSubTaskSaga,
    readerViewerPageSaga: readerTaskOrchestrationSaga,
    clinicalTrialInventorySaga,
    tabCoordinationSaga,
    formManagementSaga,
    segmentationSaga,
    queriesSaga,
  },
};
